import { browserHistory } from 'react-router';

import { get } from 'lodash';
import { LoggerStatusEnum, sendLog } from 'ui-model';

import signOut from '../actions/signOut';
import configService from '../services/configService';
import storage from '../services/storageService';

import axiosClient from './axiosClient';
import StoreInstance from './StoreInstance';

async function fetchGraphQL(text: any, variables: any, queryName: String) {
  const response: any = await axiosClient
    .request({
      validateStatus: () => true,
      url: `${configService.getApiGraphQLPath()}`,
      method: 'POST',
      headers: {
        'x-access-token': (window as any).token || storage.getToken(),
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        query: text,
        variables,
      }),
    })
    .catch((error) => {
      sendLog(`GraphQL error on: ${queryName}`, { queryName, query: text, error }, LoggerStatusEnum.error);
    });

  // Check if response.json exists to avoid sending repeted logs or logs from fetchs that has errors
  const cleanResponse = response ? response.data : null;
  if (cleanResponse) {
    sendLog(`GraphQL data from: ${queryName}`, { queryName, query: text }, LoggerStatusEnum.info);
  }

  const is401Error = get(response, 'status') === 401;
  const isOnEmbedPage = /\/embed\//.test(window.location.href);

  if (is401Error && isOnEmbedPage) {
    browserHistory.push('/embederror');
  } else if (is401Error && StoreInstance.store) {
    StoreInstance.store.dispatch(signOut({}));
  }
  // Get the response as JSON
  return cleanResponse;
}

export default fetchGraphQL;
